// Libs
import React from 'react';
// Components
import OrdersOverview from '../OrdersOverview/OrdersOverview';

const OrdersPaid = props => (
	<OrdersOverview {...props} orderFlowType='orders_paid' />
);
export default OrdersPaid;
